import { makeAuthedRequest } from "utils/makeAuthedRequest";
import { useMutation, useQueryClient } from "react-query";

export const useVerifyPopUp = () => {
  const queryClient = useQueryClient();

  const phoneSendPost = useMutation(({ contactId, phoneData }) =>
    makeAuthedRequest(`v1/settings/verify/phone/send/${contactId}`, {
      method: "POST",
      body: JSON.stringify(phoneData),
    }).then(async (res) => {
      if (res.ok) {
        return res;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const emailSendPost = useMutation(({ contactId, emailData }) =>
    makeAuthedRequest(`v1/settings/verify/email/send/${contactId}`, {
      method: "POST",
      body: JSON.stringify(emailData),
    }).then(async (res) => {
      if (res.ok) {
        return res;
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

  const phoneVerifyPost = useMutation(({ contactId, verifyData }) =>
    makeAuthedRequest(`v1/settings/verify/phone/${contactId}`, {
      method: "POST",
      body: JSON.stringify(verifyData),
    }).then(async (res) => {
      if (res.ok) {
        return res.text();
      } else {
        const body = await res.json();
        throw new Error(body.message);
      }
    })
  );

    const emailVerifyPost = useMutation(({ contactId, verifyData }) =>
      makeAuthedRequest(`v1/settings/verify/email/${contactId}`, {
        method: "POST",
        body: JSON.stringify(verifyData),
      }).then(async (res) => {
        if (res.ok) {
          return res.text();
        } else {
          const body = await res.json();
          throw new Error(body.message);
        }
      })
    );

  return {
    phoneSendPost,
    emailSendPost,
    phoneVerifyPost,
    emailVerifyPost,
  };
};
